// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import PersonTypeController from "./person_type_controller"
application.register("person-type", PersonTypeController)

import TabulatorController from "./tabulator_controller"
application.register("tabulator", TabulatorController)

import ProducerPickerController from "./producer_picker_controller"
application.register("producer-picker", ProducerPickerController)
